import { render } from "./shake-animate.vue?vue&type=template&id=07793586"
import script from "./shake-animate.vue?vue&type=script&lang=js"
export * from "./shake-animate.vue?vue&type=script&lang=js"

import "./shake-animate.vue?vue&type=style&index=0&id=07793586&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/shake-animate.vue'],['render',render],['__file',"shake-animate.vue"]])

export default __exports__